import columns from "./columns";
import searchFields from "./searchFields";
import formFields from "./formFields";
import previewFields from "./previewFields";

export default {
    entityName: "locations",
    pageTitle: "Locations",
    displayName: "locations",
    columns,
    searchFields,
    searchPlaceholder: "e.g. name:savola",
    formFields,
    previewFields,
    tableOptions: {},
    formOptions: {},
};
